import { ComponentsOverrides, ComponentsProps, Theme } from '@mui/material';

export const MuiPagination: {
    styleOverrides: ComponentsOverrides<Theme>['MuiPagination'];
    defaultProps?: ComponentsProps['MuiPagination'];
} = {
    styleOverrides: {
        ul: {
            flexWrap: 'nowrap',
        },
    },
};

export const MuiPaginationItem: {
    styleOverrides: ComponentsOverrides<Theme>['MuiPaginationItem'];
    defaultProps?: ComponentsProps['MuiPaginationItem'];
} = {
    styleOverrides: {
        root: ({ theme }) => ({
            margin: theme.spacing(0.5),
            [theme.breakpoints.down('sm')]: {
                margin: theme.spacing(1),
            },
        }),
    },
};
